require('./home.scss');

import DemandeActions from '../../../../actions/demande.actions';
import {
  TYPE_PERSONNE
} from '../../model';
import {
  FROM_RECLAMATION
} from '../../../../utils/routes.util';
export default class HomeComponent {
  constructor() {
    this.controller = HomeController;
    this.template = require('./home.html');
  }
}

// @ngInject
class HomeController {
  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
    this.saisieReclamation = window.localStorage.getItem(FROM_RECLAMATION);
  }
  $onInit() {
    // Connexion au state récupérer les données modifiées
    this.$ngRedux.dispatch(DemandeActions.reset());
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          demande: state.demande.data
        };
      }
    )(this);
    //Au premier chargement on nettoie le localstorage pour afficher  la page "Vous souhaitez :"
    window.localStorage.removeItem(FROM_RECLAMATION);
    // En cas de redirection de l'appli antenniste
    if (window.location.href.endsWith('antenniste=true')) {
      this.saisieReclamation = true;
      this.startDemande('PRO');
    }
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Action
  saisirReclamation() {
    this.saisieReclamation = true;
  }

  suivreDossier() {
    this.data.suivieAuthent = true;
    this.$ngRedux.dispatch(DemandeActions.startSuivieDossier(this.data));
  }
  startDemande(type) {
    if (type === TYPE_PERSONNE.PARTICULIER) {
      this.data.typePersonne = TYPE_PERSONNE.PARTICULIER;
    } else if (type === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      this.data.typePersonne = TYPE_PERSONNE.PROFESSIONNEL_RECEPTION;
    } else {
      this.data.typePersonne = TYPE_PERSONNE.SYNDIC_BAILLEUR;
    }
    this.$ngRedux.dispatch(DemandeActions.startNewDemande(this.data));
  }
  prevStep() {
    this.saisieReclamation = false;
  }
}



// WEBPACK FOOTER //
// ./src/modules/base/components/home/home.component.js